import { jsx as _jsx } from "react/jsx-runtime";
/** Native title tooltip wrapper: designs use `title="label · count"`. */
export function Tooltip({ label, children }) {
    return _jsx("span", { title: label, style: { display: 'inline-flex' }, children: children });
}
//# sourceMappingURL=Tooltip.js.map